import type { ExceptionFrame } from '@belvdr/shared'

/** Frames gardés au plus (cf. `MAX_EXCEPTION_FRAMES` de `@belvdr/shared`). */
const MAX_EXCEPTION_FRAMES = 50

/**
 * Pile d'appels d'une erreur (`error.stack`), lue en frames, du plus proche de l'erreur au plus
 * lointain. Deux formats : celui de V8 (Chrome, Edge, Node) et celui de Firefox et Safari.
 */

/** `    at applyCoupon (https://…/app.js:12:5)` ou `    at https://…/app.js:12:5` (V8). */
const V8_FRAME = /^\s*at (?:(.*?) \()?(.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/
/** `applyCoupon@https://…/app.js:12:5` ou `@https://…/app.js:12:5` (Firefox, Safari). */
const GECKO_FRAME = /^\s*(.*?)@(.*?)(?::(\d+))?(?::(\d+))?\s*$/

const MAX_FUNCTION_LENGTH = 512
const MAX_FILE_LENGTH = 4096

function frameOf(match: RegExpExecArray): ExceptionFrame | null {
  const [, name, file, line, column] = match
  const frame: ExceptionFrame = {}
  if (name) frame.function = name.slice(0, MAX_FUNCTION_LENGTH)
  if (file) frame.file = file.slice(0, MAX_FILE_LENGTH)
  if (line !== undefined) frame.line = Number(line)
  if (column !== undefined) frame.column = Number(column)
  return frame.function === undefined && frame.file === undefined ? null : frame
}

export function parseStack(stack: unknown): ExceptionFrame[] {
  if (typeof stack !== 'string') return []
  const lines = stack.split('\n')
  const v8 = lines.some((line) => /^\s*at /.test(line))
  const frames: ExceptionFrame[] = []
  for (const line of lines) {
    // V8 : la première ligne (et un message sur plusieurs lignes) ne commence pas par `at`.
    const match = v8 ? (/^\s*at /.test(line) ? V8_FRAME.exec(line) : null) : GECKO_FRAME.exec(line)
    const frame = match && frameOf(match)
    if (frame) frames.push(frame)
    if (frames.length === MAX_EXCEPTION_FRAMES) break
  }
  return frames
}
